export default function Terms() {
  return (
    <div style={{ padding: '80px 20px 100px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> March 30, 2025</p>

      <p>Welcome to Screen to Scene. By accessing or using our website, you agree to be bound by these Terms of Service. Please read them carefully.</p>

      <h2>1. Use of the Site</h2>
      <p>You agree to use the site only for lawful purposes and in a way that does not infringe the rights of others or restrict their use of the site.</p>

      <h2>2. Accounts and Registration</h2>
      <p>When you create an account, you agree to provide accurate information and keep your login credentials secure. You are responsible for all activity under your account.</p>

      <h2>3. Intellectual Property</h2>
      <p>All content on this site — including text, graphics, logos, and software — is the property of Screen to Scene or its content suppliers and is protected by applicable copyright and trademark laws.</p>

      <h2>4. Prohibited Activities</h2>
      <p>You may not use the site to:</p>
      <ul>
        <li>Violate any laws or regulations</li>
        <li>Post harmful, abusive, or misleading content</li>
        <li>Disrupt or compromise the site's performance or security</li>
      </ul>

      <h2>5. Third-Party Links</h2>
      <p>This site may contain links to third-party websites. We are not responsible for the content or practices of those websites.</p>

      <h2>6. Disclaimer</h2>
      <p>The site is provided "as is" and "as available" without warranties of any kind. We do not guarantee that the site will be error-free or uninterrupted.</p>

      <h2>7. Limitation of Liability</h2>
      <p>We are not liable for any direct, indirect, or consequential damages arising from your use of the site.</p>

      <h2>8. Changes to These Terms</h2>
      <p>We may update these Terms of Service from time to time. Changes will be posted here with the updated effective date.</p>

      <h2>9. Termination</h2>
      <p>We reserve the right to suspend or terminate your account at any time if you violate these terms.</p>

      <h2>10. Contact</h2>
      <p>If you have any questions about these Terms, contact us at support@screentoscreen.com.</p>
    </div>
  );
}
